import { render, staticRenderFns } from "./driver_report_details.vue?vue&type=template&id=f7ed34b8&"
import script from "./driver_report_details.vue?vue&type=script&lang=js&"
export * from "./driver_report_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports